module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche P5 (Version 1).928aaa60b65c7a1bda46c1beca1d6ec3.pdf";